export default function StatsCard({ label, value, icon }) {
  return (
    <div className="bg-white p-3 sm:p-4 rounded shadow">
      <div className="flex items-center justify-between gap-2">
        <div className="min-w-0 flex-1">
          <p className="text-gray-500 text-[11px] sm:text-sm truncate">{label}</p>
          <p className="text-lg sm:text-2xl font-bold truncate">{value}</p>
        </div>
        <i className={`fas ${icon} text-xl sm:text-3xl text-blue-500 opacity-50 flex-shrink-0`}></i>
      </div>
    </div>
  );
}